// extracted by mini-css-extract-plugin
module.exports = {"main":"ChoosePosition_main__ifVpK"};